module.exports = __webpack_public_path__ + "static/img/phlogo.9db569b7.png";